/**
 * Visible-on-focus "Skip to main content" link.
 * Place at the very top of <Layout/> so it is the first focus stop.
 *
 * Pair with <main id="main-content" tabIndex={-1}>…</main>.
 */
export function SkipLink({ targetId = "main-content", label = "Skip to main content · मुख्य सामग्रीवर जा" }: {
  targetId?: string;
  label?: string;
}) {
  return (
    <a className="skip-link" href={`#${targetId}`}>
      {label}
    </a>
  );
}
